import React from 'react';
import { observer } from 'mobx-react';
import { InterjectionStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class InterjectionCreate extends React.Component {

  onCreate = name => {
    InterjectionStore.create({data: {name}});
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default InterjectionCreate;
